import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="tac-termsPageWrapper">
      <h1 className="tac-mainTitle">Terms & Conditions</h1>
      <div className="tac-termsContainer">
        <div className="tac-contentContainer">
          <div className="tac-content">
            <div className="tac-section">
              <h2 className="tac-sectionTitle">Accepting the terms</h2>
              <div className="tac-divider"></div>
              <p className="tac-paragraph">
                These terms outline the rules and guidelines governing your use of our services, ensuring clarity and mutual understanding between you, the user, and us.
              </p>
              <p className="tac-paragraph">
                By accessing or using our platform, you agree to comply with these conditions designed to protect both parties’ rights while facilitating a seamless experience. Please read them carefully before proceeding with any transactions or engagements on our site.
              </p>
              <h3 className="tac-sectionTitle">1. Platform Features and Custom Requirements</h3>
              <p className="tac-paragraph">
                The platform features are as described in the CollabAI – Reference Guide. Any custom requirements beyond the initial features will require a new estimation, a separate proposal, and additional charges.
              </p>
              <h3 className="tac-sectionTitle">2. Software Updates</h3>
              <p className="tac-paragraph">
                Updates will be applicable only for stable released versions; beta versions or experimental features are not included unless explicitly agreed upon by both parties.
              </p>
              <p className="tac-paragraph">
                You will be notified of new available stable versions, and we will contact you for approval before implementing any updates; failure to respond within 5 business days will result in automatic deferral of updates until further notice from your end.
              </p>
              <p className="tac-paragraph">
                After software updates, any bugs that arise due to those updates will be fixed within 15 business days; critical bugs will be addressed with higher priority based on severity levels.
              </p>
              <p className="tac-paragraph">
                Updates will be provided for 1 year; after this period, additional costs may be incurred to receive further updates, subject to a new agreement between both parties.
              </p>
              <p className="tac-paragraph">
                For any future features requiring third-party credentials/access, the client will be asked before installation.
              </p>
              <p className="tac-paragraph">
                SJ Innovation LLC reserves the right to discontinue the open-source product update without any further notice.
              </p>
              <h3 className="tac-sectionTitle">3. Support and Issue Reporting</h3>
              <p className="tac-paragraph">
                You will be onboarded to a dedicated Slack channel for Issue Reporting.
              </p>
              <p className="tac-paragraph">
                When reporting issues, please provide:
                <ul>
                  <li>Steps required to reproduce the issue</li>
                  <li>Expected outcome</li>
                  <li>Any relevant additional information (e.g., screenshots, video recordings).</li>
                </ul>
              </p>
              <p className="tac-paragraph">
                Response timeframes may vary depending on issue severity but shall not exceed 3 (three) business days except during holidays or force majeure events.
              </p>
              <p className="tac-paragraph">
                Support is limited to issues directly related to the CollabAI platform and does not include general IT support or troubleshooting of third-party integrations.
              </p>
              <h3 className="tac-sectionTitle">4. Server and Credentials</h3>
              <p className="tac-paragraph">
                SJ Innovation LLC shall not bear responsibility nor liability arising out of server/account-related issues including but not limited to downtime caused by third-party service providers.
              </p>
              <p className="tac-paragraph">
                The client is responsible for managing and securing their server/account credentials.
              </p>
              <p className="tac-paragraph">
                SJ Innovation LLC will not be responsible for bearing any server, domain, AI / other service-related costs.
              </p>
              <h3 className="tac-sectionTitle">5. Project Pausing</h3>
              <p className="tac-paragraph">
                If the client fails to provide the required information for 2 weeks, SJ Innovation LLC reserves the right to pause the project. Resumption of work may take time upon receiving the required information.
              </p>
              <h3 className="tac-sectionTitle">6. Intellectual Property Rights</h3>
              <p className="tac-paragraph">
                MIT License; Copyright (c) 2024, CollabAI Software
              </p>
              <p className="tac-paragraph">
                Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
              </p>
              <p className="tac-paragraph">
                The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
              </p>
              <p className="tac-paragraph">
                THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
              </p>
              <h3 className="tac-sectionTitle">7. Data Privacy and Security</h3>
              <p className="tac-paragraph">
                SJ Innovation LLC will not access, store, or process any client data hosted on the client’s servers. The client is solely responsible for ensuring compliance with all applicable data protection and privacy laws. SJ Innovation LLC shall not be held liable for any data breaches or losses occurring on the client’s infrastructure.
              </p>
              <h3 className="tac-sectionTitle">8. Limitation of Liability</h3>
              <p className="tac-paragraph">
                SJ Innovation LLC’s total liability under this agreement shall not exceed the original price of the package ($2,000). SJ Innovation LLC shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with the use of the CollabAI platform.
              </p>
              <h3 className="tac-sectionTitle">9. Governing Law</h3>
              <p className="tac-paragraph">
                This agreement shall be governed by and construed per the laws of New York. Any disputes arising from this agreement shall be subject to the exclusive jurisdiction of the courts in New York.
              </p>
              <h3 className="tac-sectionTitle">10. Termination</h3>
              <p className="tac-paragraph">
                Either party may terminate this agreement with 30 days written notice. Upon termination, the client’s access to support and updates will cease. The client may continue to use the existing installed version of the platform but will not be entitled to any further updates or support.
              </p>
              <h3 className="tac-sectionTitle">11. Service Packages Changes</h3>
              <p className="tac-paragraph">
                Service packages listed on our website, including prices and services, are subject to change at any time. However, changes will not affect the terms agreed upon in existing contracts. This contract is valid only for the mentioned and agreed-upon services and prices provided herein. SJ Innovation LLC reserves the right to amend website offerings at its discretion without affecting existing contracts. Also, SJ Innovation LLC reserves the right to change the open-source platform name at anytime.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;